module.exports = __webpack_public_path__ + "static/media/Kanit-Light.a1433e7d.ttf";